export interface IFingerSize {
  mm:number,
  auuk:string,
  usca:string,
  eu:string,
  ch:string,
  jpc:string
}

export interface IFingerSizeFormat {
  id:'auuk'|'usca'|'eu'|'ch'|'jpc',
  name:string
}

export const FINGER_SIZE_FORMATS:IFingerSizeFormat[] = [
  {
    id: 'auuk',
    name: 'Australia & UK',
  },
  {
    id: 'usca',
    name: 'USA & Canada'
  },
  {
    id: 'eu',
    name: 'Europe'
  },
  {
    id: 'ch',
    name: 'Switzerland',
  },
  {
    id: 'jpc',
    name: 'Japan & China'
  }
]

export const FINGER_SIZES:IFingerSize[] = [
  {
    mm: 13.9,
    auuk: 'F',
    usca: '3',
    eu: '44',
    ch: '4',
    jpc: '4'
  },
  {
    mm: 14,
    auuk: 'F1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 14.1,
    auuk: 'F1/2',
    usca: '31/4',
    eu: '44,5',
    ch: '4,25',
    jpc: null
  },
  {
    mm: 14.2,
    auuk: 'F3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: '5'
  },
  {
    mm: 14.3,
    auuk: 'G',
    usca: '31/2',
    eu: '45',
    ch: '4,75',
    jpc: null
  },
  {
    mm: 14.4,
    auuk: 'G1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 14.5,
    auuk: 'G1/2',
    usca: '33/4',
    eu: '45,5',
    ch: '5,5',
    jpc: '6'
  },
  {
    mm: 14.6,
    auuk: 'G3/4',
    usca: null,
    eu: '46',
    ch: null,
    jpc: null
  },
  {
    mm: 14.7,
    auuk: 'H',
    usca: '4',
    eu: null,
    ch: '6',
    jpc: null
  },
  {
    mm: 14.8,
    auuk: 'H1/4',
    usca: null,
    eu: '46,5',
    ch: null,
    jpc: '7'
  },
  {
    mm: 14.9,
    auuk: 'H1/2',
    usca: '41/4',
    eu: null,
    ch: '6,75',
    jpc: null
  },
  {
    mm: 15,
    auuk: 'H3/4',
    usca: null,
    eu: '47',
    ch: null,
    jpc: null
  },
  {
    mm: 15.1,
    auuk: 'I',
    usca: '41/2',
    eu: '47,5',
    ch: '7,5',
    jpc: '8'
  },
  {
    mm: 15.2,
    auuk: 'I1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 15.3,
    auuk: 'I1/2',
    usca: null,
    eu: '48',
    ch: '8',
    jpc: null
  },
  {
    mm: 15.4,
    auuk: 'I3/4',
    usca: '43/4',
    eu: '48,5',
    ch: null,
    jpc: null
  },
  {
    mm: 15.5,
    auuk: 'J',
    usca: null,
    eu: null,
    ch: '8,75',
    jpc: '9'
  },
  {
    mm: 15.6,
    auuk: 'J1/4',
    usca: null,
    eu: '49',
    ch: null,
    jpc: null
  },
  {
    mm: 15.7,
    auuk: 'J1/2',
    usca: '5',
    eu: null,
    ch: '9,25',
    jpc: null
  },
  {
    mm: 15.8,
    auuk: 'J3/4',
    usca: null,
    eu: '49,5',
    ch: null,
    jpc: null
  },
  {
    mm: 15.9,
    auuk: 'K',
    usca: '51/4',
    eu: '50',
    ch: '10',
    jpc: '9,5'
  },
  {
    mm: 16,
    auuk: 'K1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 16.1,
    auuk: 'K1/2',
    usca: '51/2',
    eu: '50,5',
    ch: '10,5',
    jpc: '10'
  },
  {
    mm: 16.2,
    auuk: 'K3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 16.3,
    auuk: 'L',
    usca: '53/4',
    eu: '51',
    ch: '11,25',
    jpc: '10,5'
  },
  {
    mm: 16.4,
    auuk: 'L1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 16.5,
    auuk: 'L1/2',
    usca: '6',
    eu: '51,5',
    ch: '11,75',
    jpc: '11'
  },
  {
    mm: 16.6,
    auuk: 'L3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 16.7,
    auuk: 'M',
    usca: '61/4',
    eu: '52,5',
    ch: '12,5',
    jpc: '12'
  },
  {
    mm: 16.8,
    auuk: 'M1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 16.9,
    auuk: 'M1/2',
    usca: '61/2',
    eu: '53',
    ch: '13,25',
    jpc: '13'
  },
  {
    mm: 17,
    auuk: 'M3/4',
    usca: null,
    eu: '53,5',
    ch: null,
    jpc: null
  },
  {
    mm: 17.1,
    auuk: 'N',
    usca: '63/4',
    eu: null,
    ch: '13,75',
    jpc: null
  },
  {
    mm: 17.2,
    auuk: 'N1/4',
    usca: null,
    eu: '54',
    ch: null,
    jpc: null
  },
  {
    mm: 17.3,
    auuk: 'N1/2',
    usca: '7',
    eu: null,
    ch: '14,5',
    jpc: '14'
  },
  {
    mm: 17.4,
    auuk: 'N3/4',
    usca: null,
    eu: '54,5',
    ch: null,
    jpc: null
  },
  {
    mm: 17.5,
    auuk: 'O',
    usca: '71/4',
    eu: '55',
    ch: '15',
    jpc: null
  },
  {
    mm: 17.6,
    auuk: 'O1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 17.7,
    auuk: 'O1/2',
    usca: '71/2',
    eu: '55,5',
    ch: '15,75',
    jpc: '15'
  },
  {
    mm: 17.8,
    auuk: 'O3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 17.9,
    auuk: 'P',
    usca: '73/4',
    eu: '56',
    ch: '16,25',
    jpc: null
  },
  {
    mm: 18,
    auuk: 'P1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 18.1,
    auuk: 'P1/2',
    usca: '8',
    eu: '57',
    ch: '17',
    jpc: '16'
  },
  {
    mm: 18.2,
    auuk: 'P3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 18.3,
    auuk: 'Q',
    usca: '81/4',
    eu: '57,5',
    ch: '17,5',
    jpc: null
  },
  {
    mm: 18.4,
    auuk: 'Q1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 18.5,
    auuk: 'Q1/2',
    usca: '81/2',
    eu: '58',
    ch: '18,25',
    jpc: '17'
  },
  {
    mm: 18.6,
    auuk: 'Q3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 18.7,
    auuk: 'R',
    usca: '83/4',
    eu: '58,5',
    ch: '19',
    jpc: null
  },
  {
    mm: 18.8,
    auuk: 'R1/4',
    usca: null,
    eu: '59',
    ch: null,
    jpc: null
  },
  {
    mm: 18.9,
    auuk: 'R1/2',
    usca: '9',
    eu: '59,5',
    ch: '19,5',
    jpc: '18'
  },
  {
    mm: 19,
    auuk: 'R3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 19.1,
    auuk: 'S',
    usca: '91/4',
    eu: '60',
    ch: '20,25',
    jpc: null
  },
  {
    mm: 19.2,
    auuk: 'S1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 19.3,
    auuk: 'S1/2',
    usca: '91/2',
    eu: '60,5',
    ch: '20,75',
    jpc: '19'
  },
  {
    mm: 19.4,
    auuk: 'S3/4',
    usca: null,
    eu: '61',
    ch: null,
    jpc: null
  },
  {
    mm: 19.5,
    auuk: 'T',
    usca: '93/4',
    eu: null,
    ch: '21,5',
    jpc: null
  },
  {
    mm: 19.6,
    auuk: 'T1/4',
    usca: null,
    eu: '61,5',
    ch: null,
    jpc: null
  },
  {
    mm: 19.7,
    auuk: 'T1/2',
    usca: '10',
    eu: '62',
    ch: '22',
    jpc: '20'
  },
  {
    mm: 19.8,
    auuk: 'T3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 19.9,
    auuk: 'U',
    usca: '101/4',
    eu: '62,5',
    ch: '22,75',
    jpc: '21'
  },
  {
    mm: 20,
    auuk: 'U1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 20.1,
    auuk: 'U1/2',
    usca: '101/2',
    eu: '63',
    ch: '23,25',
    jpc: '22'
  },
  {
    mm: 20.2,
    auuk: 'U3/4',
    usca: null,
    eu: '64',
    ch: null,
    jpc: null
  },
  {
    mm: 20.3,
    auuk: 'V',
    usca: '103/4',
    eu: null,
    ch: '24',
    jpc: null
  },
  {
    mm: 20.4,
    auuk: 'V1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 20.5,
    auuk: 'V1/2',
    usca: '11',
    eu: '64,5',
    ch: '24,75',
    jpc: '23'
  },
  {
    mm: 20.6,
    auuk: 'V3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 20.7,
    auuk: 'W',
    usca: '111/4',
    eu: '65',
    ch: '25,25',
    jpc: null
  },
  {
    mm: 20.8,
    auuk: 'W1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 20.9,
    auuk: 'W1/2',
    usca: '111/2',
    eu: '66',
    ch: '26',
    jpc: '24'
  },
  {
    mm: 21,
    auuk: 'W3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 21.1,
    auuk: 'X',
    usca: '113/4',
    eu: '66,5',
    ch: '26,5',
    jpc: null
  },
  {
    mm: 21.2,
    auuk: 'X1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 21.3,
    auuk: 'X1/2',
    usca: '12',
    eu: '67',
    ch: '27,25',
    jpc: '25'
  },
  {
    mm: 21.4,
    auuk: 'X3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 21.5,
    auuk: 'Y',
    usca: '121/4',
    eu: '67,5',
    ch: '27,75',
    jpc: null
  },
  {
    mm: 21.6,
    auuk: 'Y1/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 21.7,
    auuk: 'Y1/2',
    usca: null,
    eu: '68',
    ch: '28,5',
    jpc: null
  },
  {
    mm: 21.8,
    auuk: 'Y3/4',
    usca: null,
    eu: '68,5',
    ch: null,
    jpc: null
  },
  {
    mm: 21.9,
    auuk: 'Z',
    usca: '121/2',
    eu: null,
    ch: '29',
    jpc: '26'
  },
  {
    mm: 22,
    auuk: 'Z1/4',
    usca: null,
    eu: '69',
    ch: null,
    jpc: null
  },
  {
    mm: 22.1,
    auuk: 'Z1/2',
    usca: '123/4',
    eu: '69,5',
    ch: '29,75',
    jpc: null
  },
  {
    mm: 22.2,
    auuk: 'Z3/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 22.3,
    auuk: 'Z+1',
    usca: '13',
    eu: '70',
    ch: '30,5',
    jpc: '27'
  },
  {
    mm: 22.4,
    auuk: 'Z+11/4',
    usca: null,
    eu: '70,5',
    ch: null,
    jpc: null
  },
  {
    mm: 22.5,
    auuk: 'Z+11/2',
    usca: '131/4',
    eu: null,
    ch: '31',
    jpc: null
  },
  {
    mm: 22.6,
    auuk: 'Z+13/4',
    usca: null,
    eu: '71',
    ch: null,
    jpc: null
  },
  {
    mm: 22.7,
    auuk: 'Z+2',
    usca: '131/2',
    eu: '71,5',
    ch: '31,75',
    jpc: '28'
  },
  {
    mm: 22.8,
    auuk: 'Z+21/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 22.9,
    auuk: 'Z+21/2',
    usca: '133/4',
    eu: '72',
    ch: '32,25',
    jpc: null
  },
  {
    mm: 23,
    auuk: 'Z+23/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 23.1,
    auuk: 'Z+3',
    usca: '14',
    eu: '72,5',
    ch: '33',
    jpc: '29'
  },
  {
    mm: 23.2,
    auuk: 'Z+31/4',
    usca: null,
    eu: '73',
    ch: null,
    jpc: null
  },
  {
    mm: 23.3,
    auuk: 'Z+31/2',
    usca: '141/4',
    eu: null,
    ch: '33,5',
    jpc: null
  },
  {
    mm: 23.4,
    auuk: 'Z+33/4',
    usca: null,
    eu: '73,5',
    ch: null,
    jpc: null
  },
  {
    mm: 23.5,
    auuk: 'Z+4',
    usca: '141/2',
    eu: null,
    ch: '34,25',
    jpc: '30'
  },
  {
    mm: 23.6,
    auuk: 'Z+41/4',
    usca: null,
    eu: '74',
    ch: null,
    jpc: null
  },
  {
    mm: 23.7,
    auuk: 'Z+41/2',
    usca: '143/4',
    eu: '74,5',
    ch: '34,75',
    jpc: null
  },
  {
    mm: 23.8,
    auuk: 'Z+43/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 23.9,
    auuk: 'Z+5',
    usca: '15',
    eu: '75',
    ch: '35,5',
    jpc: '31'
  },
  {
    mm: 24,
    auuk: 'Z+51/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 24.1,
    auuk: 'Z+51/2',
    usca: '151/4',
    eu: '75,5',
    ch: '36',
    jpc: null
  },
  {
    mm: 24.2,
    auuk: 'Z+53/4',
    usca: null,
    eu: '76',
    ch: null,
    jpc: null
  },
  {
    mm: 24.3,
    auuk: 'Z+6',
    usca: '151/2',
    eu: null,
    ch: '36,75',
    jpc: '32'
  },
  {
    mm: 24.4,
    auuk: 'Z+61/4',
    usca: null,
    eu: '76,5',
    ch: null,
    jpc: null
  },
  {
    mm: 24.5,
    auuk: 'Z+61/2',
    usca: '153/4',
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 24.6,
    auuk: 'Z+63/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 24.7,
    auuk: 'Z+7',
    usca: '16',
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 24.8,
    auuk: 'Z+71/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 24.9,
    auuk: 'Z+71/2',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25,
    auuk: 'Z+73/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.1,
    auuk: 'Z+8',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.2,
    auuk: 'Z+81/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.3,
    auuk: 'Z+81/2',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.4,
    auuk: 'Z+83/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.5,
    auuk: 'Z+9',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.6,
    auuk: 'Z+91/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.7,
    auuk: 'Z+91/2',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.8,
    auuk: 'Z+93/4',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  },
  {
    mm: 25.9,
    auuk: 'Z+10',
    usca: null,
    eu: null,
    ch: null,
    jpc: null
  }
]